import { isRouteAuthorized } from './menuPermission'

let utils = {};

utils.title = function (title) {
  const appTitle = '数据填报';
  const pageTitle = title ? String(title).replace(/\s*\|\s*数据填报\s*$/, '').trim() : '';
  window.document.title = pageTitle ? `${pageTitle} | ${appTitle}` : appTitle;
};

export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return;
  let i = -1;
  let len = arr.length;
  while (++i < len) {
    let item = arr[i];
    fn(item, i, arr);
  }
};

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
export const getHomeRoute = routers => {
  let i = -1;
  let len = routers.length;
  let homeRoute = {};
  while (++i < len) {
    let item = routers[i];
    if (item.children && item.children.length) {
      let res = getHomeRoute(item.children);
      if (res.name) return res;
    } else {
      if (item.name === 'home') homeRoute = item;
    }
  }
  return homeRoute;
};

/**
 * @param {Array} routers 路由列表数组
 * @description 找到当前菜单中的第一个可见叶子路由，作为默认进入页面
 */
export const getFirstMenuRoute = (routers, predicate) => {
  let i = -1;
  let len = routers.length;
  while (++i < len) {
    let item = routers[i];
    if (item.meta && item.meta.hideInMenu) continue;
    if (hasChild(item)) {
      let childRoute = getFirstMenuRoute(item.children, predicate);
      if (childRoute && childRoute.name) return childRoute;
    } else if (item.name && (!predicate || predicate(item))) {
      return item;
    }
  }
  return {};
};

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = routeMetched => {
  let res = routeMetched.filter(item => {
    return item.meta === undefined || !item.meta.hide
  }).map(item => {
    let obj = {
      icon: (item.meta && item.meta.icon) || '',
      name: item.name,
      meta: item.meta
    };
    return obj
  });
  res = res.filter(item => {
    return !(item.meta.hideInMenu && !item.name)
  });
  return [...res];
};


/**
 * 获取当前登陆的用户的权限集合数据
 * @param list {Array} 所有的路由集合数据
 * @param access {Array} 当前允许登陆的路由集合数据
 */
export const getLoginMenuList = (list, access) => {
  let res = [];
  forEach(list, item => {
    if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
      const children = hasChild(item) ? getLoginMenuList(item.children, access) : []
      const menuMeta = access && access.routeMenus ? access.routeMenus[item.name] : null
      let obj = {
        icon: (menuMeta && menuMeta.icon) || '',
        name: item.name,
        meta: Object.assign({}, item.meta, {
          title: (menuMeta && menuMeta.title) || (item.meta && item.meta.title),
          icon: (menuMeta && menuMeta.icon) || ''
        }),
        code: item.code,
        path: item.path
      };
      if (children.length) {
        obj.children = children
      }
      if (showThisMenuEle(item, access) || children.length) res.push(obj);
    }
  })
  res.sort((a, b) => {
    const routeOrders = access && access.routeOrders ? access.routeOrders : {}
    return String(routeOrders[a.name] || '9999').localeCompare(String(routeOrders[b.name] || '9999'))
  })
  return res;
}

/**
 * 功能描述： 判断当前登录的用户是否拥有节点的权限
 * @param item
 * @param access
 * @returns {boolean}
 */
const showThisMenuEle = (item, access) => {
  return isRouteAuthorized(item, access)
}

export const hasChild = (item) => {
  return item.children !=undefined && item.children.length !== 0
};

export default utils;



// WEBPACK FOOTER //
// ./src/libs/utils.js